var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 691,
    height: 1152,
    viewBox: "0 0 691 1152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.987793,
    width: 690.614,
    height: 1152.01,
    fill: "#5046E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M529.076 0.988003L271.207 0H254.411L1.48193 235.639V548.342C37.3794 500.918 154.227 388.878 334.439 320.113C514.651 251.348 539.12 79.0403 529.076 0.988003Z",
    fill: "#463FD5",
    stroke: "#463FD5",
    strokeWidth: 0.197601
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.584 183.769C72.3219 199.972 20.4187 258.363 0 285.533V0H270.713C285.533 140.791 171.913 163.515 116.584 183.769Z",
    fill: "#3F35C4",
    stroke: "#3F35C4",
    strokeWidth: 0.197601
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M574.596 968.595C618.644 952.336 670.295 893.743 690.614 866.479L690.614 1153L421.216 1153C406.468 1011.72 519.536 988.92 574.596 968.595Z",
    fill: "#3F35C4",
    stroke: "#3F35C4",
    strokeWidth: 0.197601
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.181 914.772C240.183 990.392 249.054 1066.51 251.025 1153H533.407C539.813 1102.42 564.947 1002.16 614.228 1005.71C663.51 1009.27 685.686 967.328 690.614 945.91L690.122 632.557C631.773 628.207 603.879 685.441 596.98 714.602C593.201 736.678 575.197 787.948 533.407 816.417C481.168 852.003 467.556 823.458 343.181 914.772Z",
    fill: "#473FD5",
    stroke: "#473FD5",
    strokeWidth: 0.197601
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogin);
export default __webpack_public_path__ + "static/media/background-login.8d9ccd238cab1cfc9777610840e34fc8.svg";
export { ForwardRef as ReactComponent };